import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { ContactProjectsListDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  BulkContactAssignmentProjectDocument,
  BulkContactAssignmentProjectMutation,
  ContactsDetailsPageRouteDocument,
  ProjectForSelectFragment,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import handleResultWithFlash from 'modules/finance/lib/handleResultWithFlash'
import { ProjectSelector } from 'modules/project_management/components/selectors/ProjectSelector'

const ContactsAddProjectsModal = ({
  onClose,
  clientId,
}: {
  onClose: () => void
  clientId: number
}) => {
  const { company } = useCurrentSession()
  const [selectedProjects, setSelectedProjects] = useState<ProjectForSelectFragment[]>([])

  const [manage, { loading }] = useMutation(BulkContactAssignmentProjectDocument, {
    extractorFn: (data: BulkContactAssignmentProjectMutation) =>
      data.projectManagementMutations.bulkClientAssignmentProjectmanagementProject,
  })

  const submitModal = async () => {
    const result = await manage({
      variables: {
        companyId: company.id,
        projectIds: selectedProjects.map((project) => project.id),
        clientId: clientId,
      },
      awaitRefetchQueries: true,
      refetchQueries: [ContactProjectsListDataTableDocument, ContactsDetailsPageRouteDocument],
    })

    const handled = handleResult(result, handleResultWithFlash())

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('finance.clients.wizard.messages.success'),
      })
      track(trackingEvents.accounting.editClientProjects)
      onClose()
    }

    return handled
  }
  return (
    <Modal
      title={i18n.t('finance.contacts.contact_details.projects.no_projects_message.button')}
      onClose={onClose}
      onSubmit={submitModal}
      footer={
        <Button disabled={selectedProjects.length == 0 || loading} submit>
          {i18n.t('common.submit')}
        </Button>
      }
    >
      <ProjectSelector
        alwaysOpen
        multiple
        withoutClient
        value={selectedProjects}
        onChange={setSelectedProjects}
      />
    </Modal>
  )
}

export default ContactsAddProjectsModal
